<template>
  <div>
    <defaultImg class="banner" :src="selectBanner()"></defaultImg>
    <div class="content typeArea">
        <breadcrumb class="breadcrumb"></breadcrumb>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import '@/styles/ourServiceCommonCss.less'
export default {
  name: 'ourServiceLayout',
  data () {
    return {
        selectBanner(){
            if(this.$route.name=='ourServiceMainPage'){
                return require('@/assets/images/image50.png')
            }else if(this.$route.name=='ourServicePesticide'){
                return require('@/assets/images/image55.png')
            }else if(this.$route.name=='chemicalRegister'){
                return require('@/assets/images/image59.png')
            }else if(this.$route.name=='makeUp'){
                return require('@/assets/images/image161.png')
            }else if(this.$route.name=='otherService'){
                return require('@/assets/images/image73.png')
            }
        }
    }
  },
  methods: {}
}
</script> 

<style lang='less' scoped>
    .banner{
        height: 600px;
        width: 100%;
        object-fit: cover;
    }
    .content{
        .breadcrumb{
            margin: 40px 0 70px 0;
        }
    }
</style>
